import { ComponentProps, FC, MouseEvent } from 'react'
import { useHistory } from 'react-router'

import Button from './Button'

type ButtonRouterLinkProps = {
  to: string
  onClick?: (e?: MouseEvent<HTMLButtonElement>) => any
} & ComponentProps<typeof Button>

const ButtonRouterLink: FC<ButtonRouterLinkProps> = ({
  to,
  onClick,
  ...props
}) => {
  const history = useHistory()

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()

    if (onClick) {
      onClick(e)
    }

    history.push(to)
  }

  return <Button onClick={handleClick} {...props} />
}

export default ButtonRouterLink
